import React from 'react';
import { IconBase } from '../Base';
export const IconCHF = (props) => (React.createElement(IconBase, { ...props, viewportSize: 24 },
    React.createElement("g", { clipPath: "url(#clip0_2_9107)" },
        React.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#D80027" }),
        React.createElement("path", { d: "M18.2609 9.91307H14.087V5.73914H9.91306V9.91307H5.73917V14.087H9.91306V18.2609H14.087V14.087H18.2609V9.91307Z", fill: "#F0F0F0" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2_9107" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
//# sourceMappingURL=CHF.js.map